<template>
  <section class="section">
    <div class="container">
      <h1 class="title">{{ $translate('soles') | capitalize }}</h1>
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <b-button
              v-if="permissions.canCreate"
              type="is-primary"
              icon-right="plus"
              @click="
                $router.push({
                  name: 'newSole',
                  params: { id: -1, module: module },
                })
              "
            ></b-button>
          </div>
        </div>
        <div class="level-right"></div>
      </div>
      <b-table
        :data="filteredData"
        :paginated="tableOptions.isPaginated"
        :narrowed="true"
        :per-page="tableOptions.perPage"
        :current-page.sync="tableOptions.currentPage"
        :pagination-simple="tableOptions.isPaginationSimple"
        :sort-icon="tableOptions.sortIcon"
        :sort-icon-size="tableOptions.sortIconSize"
        :loading="tableOptions.loading"
        hoverable
        :scrollable="true"
      >
        <template slot-scope="props">
          <b-table-column field="soleName" :label="$translate('name') | capitalize">
            {{ props.row.commercial_name ? props.row.commercial_name : '-' }}
          </b-table-column>

          <b-table-column field="soleImage" :label="$translate('image') | capitalize">
            <img v-bind:src="props.row.image" width="100px" height="auto" />
          </b-table-column>

          <b-table-column field="foggia" :label="$translate('foggia') | capitalize">
            {{ props.row.foggia.commercial_name }}
          </b-table-column>

          <b-table-column field="tread" :label="$translate('tread') | capitalize">
            {{ props.row.tread && props.row.tread.commercial_name ? props.row.tread.commercial_name : '-' }}
          </b-table-column>

          <b-table-column field="tread_color" :label="$translate('color') | capitalize">
            {{ props.row.color.commercial_name }}
          </b-table-column>

          <b-table-column
            v-if="$moduleConfiguration[module].soleHasCustomSizes"
            field="customSizes"
            :label="$translate('custom_sizes') | capitalize"
          >
            {{ props.row.sizes.min }} - {{ props.row.sizes.max }}
          </b-table-column>

          <b-table-column :label="$translate('action') | capitalize">
            <a
              v-if="permissions.canEdit"
              @click="
                $router.push({
                  name: 'editSole',
                  params: { id: props.row.id, module: module },
                })
              "
            >
              <b-icon icon="pencil-outline"></b-icon>
            </a>
            <a @click="askForShapes(props.row.id)">
              <b-icon icon="format-list-checkbox"></b-icon>
            </a>
            <a
              v-if="permissions.canCreate"
              @click="
                $router.push({
                  name: 'newSole',
                  params: { idtocopy: props.row.id, module: module },
                })
              "
            >
              <b-icon icon="content-copy"></b-icon>
            </a>
            <a v-if="permissions.canDelete" @click="deleteOccurence(props.row.id)">
              <b-icon icon="delete-outline"></b-icon>
            </a>
          </b-table-column>
        </template>
      </b-table>
    </div>
    <b-modal :active.sync="isComponentModalShapeListActive" has-modal-card trap-focus aria-role="dialog" aria-modal>
      <div class="modal-card" style="width: auto;">
        <header class="modal-card-head">
          <p class="modal-card-title">
            {{ $translate('shapes') | capitalize }}
          </p>
        </header>
        <section class="modal-card-body">
          <ul>
            <li v-for="shape in shapeList" :key="shape.id">{{ shape.commercial_name }} - {{ shape.fit_code }}</li>
          </ul>
        </section>
        <footer class="modal-card-foot">
          <button class="button" type="button" @click="isComponentModalShapeListActive = false">
            {{ $translate('close') | capitalize }}
          </button>
        </footer>
      </div>
    </b-modal>
  </section>
</template>

<script>
import mainMixin from '@/helpers/mixins/mainMixin'
import permissionMixin from '@/helpers/mixins/permissionMixin'

export default {
  name: 'Soles',
  components: {},
  mixins: [mainMixin, permissionMixin],
  props: ['module'],
  data() {
    return {
      loading: true,
      isComponentModalShapeListActive: false,
      shapeList: [],
    }
  },
  async mounted() {
    let permissionDenied = true
    switch (this.userInfo.type) {
      case 'A':
        permissionDenied = false
        this.permissions.canCreate = true
        this.permissions.canEdit = true
        this.permissions.canHide = true
        this.permissions.canDelete = true
        break
      case 'I':
        if (this.userInfo.level === 'S' || this.userInfo.level === '2') {
          this.permissions.canCreate = true
          this.permissions.canEdit = true
          this.permissions.canDelete = true
        }
        permissionDenied = false
        break
    }
    if (permissionDenied) this.$router.push('/forbidden')
    await this.loadData()
  },
  methods: {
    deleteOccurence(idtoerase) {
      this.$buefy.dialog.confirm({
        title: this.$translate('attention'),
        message: this.$translate('sole_message_destroy'),
        cancelText: this.$translate('undo'),
        confirmText: this.$translate('sole_message_confirm'),
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          this.$db
            .collection(this.$moduleConfiguration[this.module].soles)
            .doc(idtoerase)
            .delete()
            .then(async () => {
              await this.loadData()
              this.$buefy.notification.open({
                duration: 3000,
                message: this.$translate('success_delete'),
              })
            })
        },
      })
    },
    async loadData() {
      let newTableData = []
      this.$db
        .collection(this.$moduleConfiguration[this.module].soles)
        .orderBy('commercial_name', 'asc')
        .get()
        .then(snapshot => {
          snapshot.forEach(doc => {
            let sole = doc.data()
            sole.id = doc.id
            newTableData.push(sole)
          })
          this.filteredData = newTableData
          this.tableOptions.loading = false
        })
    },
    async askForShapes(idToRequest) {
      this.isSaveDisabled = true
      const tempShapeList = []
      await this.$db
        .collection(this.$moduleConfiguration[this.module].soles)
        .doc(idToRequest)
        .get()
        .then(doc => {
          const sole = doc.data()
          sole.shapes.forEach(shape => {
            tempShapeList.push(shape)
            this.shapeList = tempShapeList
          })
        })
      this.isComponentModalShapeListActive = true
    },
  },
}
</script>

<style scoped>
.modal-card {
  min-width: 400px;
}
</style>
